import { gql } from 'graphql-request';

export default gql`
  query Callflows(
    $skip: Int
    $take: Int
    $orderBy: JSON
    $filters: JSON
    $mask: String
  ) {
    callflows(
      skip: $skip
      take: $take
      orderBy: $orderBy
      filters: $filters
      mask: $mask
    ) {
      totalCount
      skip
      take
      callflows {
        id
        account_id
        doc
        listing
        createdAt
        updatedAt
        usedBy
        Schedules
        Owner {
          id
          doc
          extra
        }
      }
    }
  }
`;
